module.exports = __webpack_public_path__ + "media/reskin-images/logo--cra-reversed-89921be8.svg";